<script lang="ts" setup>

  import { useI18n } from 'vue-i18n'

  import { BngNavMenu } from '../nav-menu'

  type Props = {
    disconnected?: boolean
  }
  const props = defineProps<Props>()

  const { t } = useI18n()
</script>

<template>
  <div class="c-mobile-nav-dropdown">
    <BngNavMenu class="light-column" />
    <ButtonAndLink
      v-if="props.disconnected"
      class="bottom"
    >
      <template #button>
        <NuxtLink to="login">
          {{ t("authentication.connect") }}
        </NuxtLink>
      </template>
      <template #caption>
        {{ t("authentication.no-account") }}
      </template>
      <template #link>
        <NuxtLink to="register">
          {{ t("authentication.register") }}
        </NuxtLink>
      </template>
    </ButtonAndLink>
  </div>
</template>

<style scoped>
.c-mobile-nav-dropdown {
  position: relative;
  display: flex;
  width: 100%;
  height: 100%;
  flex-direction: column;
  justify-content: space-between;
  padding: 1.5em;

  .bottom {
    display: flex;
    width: 100%;
    flex-direction: column;
  }
}
</style>
